/* eslint-disable @typescript-eslint/no-explicit-any */
import { PAYMENT } from "../enums/Payment";
import { ERequestMethods } from "../enums/RequestMethod";
import { request } from "../libs/request";
import {
  EXeroPaymentStatus,
  EXeroPaymentType,
  IItemPayment,
  IPayment,
  IPaymentHistory,
  IUpdateAssetXeroPayment,
  IXeroPayment,
} from "../types/Payment";
import {
  IRequestArgs,
  IResponseData,
  IUpdateResult,
  ListResponseData,
} from "../types/requests";

const connectXeroPaymentConfirmation = () => {
  return request<
    IResponseData<{
      url: string; // login xero url to confirm payment from client
    }>
  >({
    method: ERequestMethods.GET,
    url: PAYMENT.CONNECT_XERO,
  });
};

const verifyXeroCallback = (params: any) => {
  return request<IResponseData<any>>({
    method: ERequestMethods.GET,
    url: `${PAYMENT.VERIFY_XERO_CALLBACK}${params}`,
  });
};

const findOrCreateXeroPayment = ({
  typeId,
  type,
  promotionCode,
}: {
  typeId: string;
  type: EXeroPaymentType;
  promotionCode?: string;
}) => {
  return request<IResponseData<IXeroPayment>>({
    method: ERequestMethods.POST,
    url: PAYMENT.FIND_OR_CREATE,
    data: {
      typeId,
      type,
      promotionCode,
    },
  });
};

const findXeroPayment = (paymentId: string) => {
  return request<IResponseData<IXeroPayment>>({
    method: ERequestMethods.GET,
    url: `${PAYMENT.DETAIL(paymentId)}`,
  });
};

const getOnePayment = (params: Record<string, any>) => {
  return request<IResponseData<IXeroPayment>>({
    method: ERequestMethods.GET,
    url: PAYMENT.GET_CURRENT,
    params,
  });
};

const getPaymentIsPendingByUser = () => {
  return request<IResponseData<IXeroPayment | null>>({
    method: ERequestMethods.GET,
    url: PAYMENT.GET_CURRENT,
    params: {
      status: EXeroPaymentStatus.PENDING,
      type: EXeroPaymentType.PACKAGE,
    },
  });
};

const removePayment = (paymentId: string) => {
  return request<IResponseData<any>>({
    method: ERequestMethods.DELETE,
    url: PAYMENT.DELETE(paymentId),
  });
};

const rejectPayment = ({
  xeroInvoiceID,
  reason,
}: {
  xeroInvoiceID: string;
  reason: string;
}) => {
  return request<IResponseData<any>>({
    method: ERequestMethods.POST,
    url: PAYMENT.REJECT,
    data: {
      xeroInvoiceID,
      reason,
    },
  });
};

const getAllPayment = ({ queryParams }: IRequestArgs) => {
  const query = {
    sort: queryParams?.query?.sort,
    ...queryParams?.query?.search,
    ...queryParams?.pagination,
  };
  return request<ListResponseData<IItemPayment>>({
    method: ERequestMethods.GET,
    url: PAYMENT.MAIN,
    params: query,
  });
};

const approvePayment = (xeroInvoiceID: string) => {
  return request<IResponseData<IPayment>>({
    method: ERequestMethods.POST,
    url: PAYMENT.APPROVE,
    data: {
      xeroInvoiceID: xeroInvoiceID,
    },
  });
};

const historyPaymentDetail = (xeroInvoiceID: string) => {
  return request<IResponseData<IPaymentHistory>>({
    method: ERequestMethods.GET,
    url: `${PAYMENT.PAYMENT_HISTORY_DETAIL}?filter[xeroPaymentId]=${xeroInvoiceID}`,
  });
};

const updateAssetXeroPayment = (data: IUpdateAssetXeroPayment) => {
  return request<IResponseData<IUpdateResult>>({
    method: ERequestMethods.PUT,
    url: PAYMENT.ASSET,
    data,
  });
};

const PaymentRepository = Object.freeze({
  connectXeroPaymentConfirmation,
  verifyXeroCallback,
  findOrCreateXeroPayment,
  findXeroPayment,
  getPaymentIsPendingByUser,
  removePayment,
  getOnePayment,
  rejectPayment,
  getAllPayment,
  approvePayment,
  historyPaymentDetail,
  updateAssetXeroPayment,
});

export default PaymentRepository;
